import styled from "styled-components";

export const AddDepartmentModalWrapper = styled("div")(() => {
  return {
    "& .option": {
      cursor: "pointer",
      padding: "calc(var(--cardPadding) / 4) calc(var(--cardPadding) / 2)",
      "& p": {
        marginBlock: 0,
        fontSize: "0.88rem",
      },
      "&:hover": {
        backgroundColor: "var(--color-primary-hover)",
        "& p": {
          color: "var(--color-text)",
        },
      },
      "&:not(:last-child)": {
        borderBottom: "1px solid #e8e8e8",
      },
    },
  };
});
